@if (chips.length) {
  <div class="chips-wrapper"
    >
    <mat-chip-set role="list"
      class="mat-mdc-chip-set-stacked"
      [ngClass]="{'collapsed': !(expanded || chips.length === 1)}"
      [@expand]="expanded || chips.length === 1 ? 'expanded' : 'collapsed'"
      aria-orientation="vertical">
      <div #content class="content">
        <ng-content></ng-content>
      </div>
      @if (!content.innerHTML.trim()) {
        @for (chip of chips; track chip) {
          <mat-chip
            role="listitem"
            [matTooltipPosition]="tooltipPosition"
            [matTooltip]="chip">
            {{ chip }}
          </mat-chip>
        }
      }
    </mat-chip-set>
    @if (chips.length > 1) {
      <button mat-icon-button
        [@rotate180]="expanded ? 'rotate' : 'void'"
        [matTooltip]="(expanded ? 'VIEW_LESS' : 'VIEW_MORE') | translate"
        [ngStyle]="{'align-items': expanded ? 'start' : 'center'}"
        (click)="onToggle()">
        <mat-icon>expand_more</mat-icon>
      </button>
    }
  </div>
}
